import { formatFileSize, getFileType } from '@/utils/file';

import alert from '@/utils/shared/alert';
import { useTranslation } from 'react-i18next';

type useImageValidatorArgs = {
  accept: string;
  limit: number;
};

export const useImageValidator = ({ accept, limit }: useImageValidatorArgs) => {
  const [t] = useTranslation('translation', {
    keyPrefix: 'common',
  });

  const validateType = (file: File) => {
    const fileType = getFileType(file);
    const allowedTypes = accept.split(',');

    if (allowedTypes.includes(fileType)) return true;

    alert.warning(
      t('acceptPermited', {
        accept,
      }),
    );

    return false;
  };

  const validateSize = (file: File) => {
    if (file.size > limit) {
      alert.warning(t('fileSizeLimit', { limit: formatFileSize(limit) }));
      return false;
    }
    return true;
  };

  const validate = (file: File) => {
    return validateType(file) && validateSize(file);
  };

  return { validate, validateType, validateSize };
};
